import { render, staticRenderFns } from "./ProcessTableComponent.vue?vue&type=template&id=9fd196e6&scoped=true&"
import script from "./ProcessTableComponent.vue?vue&type=script&lang=js&"
export * from "./ProcessTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd196e6",
  null
  
)

export default component.exports